import React, { useState } from 'react';
import { colors } from '../../../../components/css';

/**
 * @typedef {"start" | "center" | "end"} Position
 * @typedef {"small" | "medium" | "large" } Size
 */

/**
 * BookmarkSVG component
 *
 * @param {Object} props - Component props
 * @param {function} props.onClick - Click event handler
 * @param {boolean} props.selected - Indicates if the bookmark is selected
 * @param {boolean} props.isStatic - Declare if image is static
 * @param {Position} [props.position="center"] - Position of the bookmark
 * @param {Size} [props.size="medium"] - Size of the badge
 * @returns {JSX.Element}
 */

function BookmarkSVG({ onClick, selected, isStatic, position, size }) {
  const [hovered, setHovered] = useState(false);
  const cursorStyle = isStatic ? 'default' : 'pointer';

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const favouriteColor = '#ffb31c';

  let color;

  if (isStatic) {
    color = selected ? favouriteColor : colors.colorGrey04;
  } else if (selected) {
    color = favouriteColor;
  } else {
    color = hovered ? '#999999' : colors.colorGrey04;
  }

  let alignment;
  switch (position) {
    case 'end':
      alignment = 'flex-end';
      break;
    case 'start':
      alignment = 'flex-start';
      break;
    default:
      alignment = 'center';
  }

  let width;
  switch (size) {
    case 'small':
      width = '16px';
      break;
    case 'medium':
      width = '24px';
      break;
    case 'large':
      width = '32px';
      break;
    default:
      width = '24px';
  }

  return (
    <div
      style={{
        cursor: { cursorStyle },
        display: 'flex',
        justifyContent: 'center',
        alignItems: alignment
      }}
      tabIndex={0}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
    >
      <svg width={width} height={width} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="12" fill={color} />
        <g clipPath="url(#clip0_257_9956)">
          <path
            d="M8.19231 17.9777C8.51234 17.9777 8.70174 17.8213 9.28956 17.3355L11.8433 15.1856C11.8759 15.1578 11.9347 15.1578 11.9608 15.1856L14.5145 17.3355C15.1023 17.8213 15.2918 17.9777 15.6118 17.9777C16.0493 17.9777 16.3041 17.732 16.3041 17.2964V7.6026C16.3041 6.54165 15.6836 6 14.4558 6H9.34834C8.12047 6 7.5 6.54165 7.5 7.6026V17.2964C7.5 17.732 7.75472 17.9777 8.19231 17.9777Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_257_9956">
            <rect width="9" height="12" fill="white" transform="translate(7.5 6)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default BookmarkSVG;
